export default __webpack_public_path__ + "static/media/image3.dd899f4d.jpg";